import { createContext, useContext } from 'react';

export type Value = {
    fetchReserves: () => Promise<void>,
};

export const ScheduleContext = createContext<Value>(null!);

export const useSchedule = () => useContext(ScheduleContext);